const INDENT_PER_DEPTH_PX = 20;
const ROW_PADDING_LEFT_PX = 8;
const EXPANDER_SLOT_PX = 24;

/** Width of the elbow that joins a row to its parent's vertical connector. */
export const CONNECTOR_ELBOW_WIDTH_PX = ROW_PADDING_LEFT_PX;

/**
 * Left offset of a row at this depth. The rows the tree draws under a branch
 * (retry, load more) line up with it, so the geometry is shared rather than
 * restated per caller.
 */
export const rowIndentPx = (depth: number) =>
  ROW_PADDING_LEFT_PX + depth * INDENT_PER_DEPTH_PX;

/** Left offset of the vertical connector that joins the children of a row at this depth. */
export const connectorLeftPx = (depth: number) =>
  rowIndentPx(depth) + EXPANDER_SLOT_PX / 2;
